import set from 'lodash/set';

import getCardTypeFromNumber from '../../utils/getCardTypeFromNumber';

export default function payoutCardMutations(formData, key, value) {
  set(formData, key, value);

  switch (key) {
    case 'cardNumber':
      set(formData, 'cardType', getCardTypeFromNumber(formData.cardNumber));
      break;

    default:
  }

  return formData;
}
